<script setup lang="ts">
import {useDate} from "@/composables/date";

const {longDate} = useDate()

interface Props {
    datetime: string
}

const props = defineProps<Props>()
</script>

<template>
    <v-tooltip
        location="bottom"
        content-class="bg-black border-sm text-tooltip text-center"
        max-width="200"
    >
        <template #activator="{ props: bind }">
            <span
                v-bind="bind"
                class="custom-text text-medium-emphasis text-start"
            >
                <slot />
            </span>
        </template>
        {{ longDate(props.datetime) }}
    </v-tooltip>
</template>

<style scoped>
</style>
